export namespace PandemieEntityTypes {
    export const VERANSTALTUNG_ENTITY = 'PAN.VERANSTALTUNG';
    export const AUFGABE_ENTITY = 'PAN.AUFGABE';
    
}

